import React from 'react';
import { Check, X, AlertTriangle, Info } from 'lucide-react';
import { useUIStore, type Toast as ToastType } from '../../stores/uiStore';
import './Toast.css';

const iconMap = {
  success: Check,
  error: X,
  warning: AlertTriangle,
  info: Info,
};

const ToastItem: React.FC<{ toast: ToastType }> = ({ toast }) => {
  const removeToast = useUIStore((s) => s.removeToast);
  const Icon = iconMap[toast.type];

  return (
    <div className={`toast toast-${toast.type}`}>
      <div className="toast-icon">
        <Icon size={16} />
      </div>
      <span className="toast-message">{toast.message}</span>
      <button className="toast-dismiss" onClick={() => removeToast(toast.id)}>
        <X size={14} />
      </button>
    </div>
  );
};

export const ToastContainer: React.FC = () => {
  const toasts = useUIStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
};
